<template>
  <div class="main-conent main-conent-minheight page-rodent">
    <okq v-if="type === 'okq'"></okq>
    <other v-else-if="type === 'other'"></other>
  </div>
</template>

<script>
import Okq from './okq'
import Other from './other'

export default {
  components: { Okq, Other },
  data() {
    return {
      type: ''
    }
  },
  mounted() {
    if (this.rodents && this.rodents[0]) {
      this.type === 'okq'
    } else {
      this.type = 'other'
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.page-rodent {
  height: 100%;
  .images-list {
    background: #fff;
  }
}
</style>
